import { render, staticRenderFns } from "./ProfileFooter.vue?vue&type=template&id=7d48ffbb&scoped=true&"
import script from "./ProfileFooter.vue?vue&type=script&lang=js&"
export * from "./ProfileFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFooter.vue?vue&type=style&index=0&id=7d48ffbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48ffbb",
  null
  
)

export default component.exports